import type { BigNumber } from 'utils/bigNumber';
import { sliceZeroDecimal } from 'utils/formatter';

import { formattingToAnchorUserVOModel } from './AnchorUserVO';
import { formattingToTermSpreadVOModel } from './TermSpreadVO';

import type { AnchorUserVO, AnchorUserVOModel } from './AnchorUserVO';
import type { TermSpreadVOModel } from './TermSpreadVO';
import type { WaitingDealerAgreementVO } from './WaitingDealerAgreementVO';

export interface TempWaitingDealerAgreementVO extends WaitingDealerAgreementVO {
  tempWaitingDealerAgreementId: number;
  anchorUserList: AnchorUserVO[];
  anchorAgreementStartDate: string;
  anchorAgreementExpiryDate: string;
  division: string;
  divisionName: string;
}

export interface TempWaitingDealerAgreementVOModel extends TempWaitingDealerAgreementVO {
  loanLimitAmount: BigNumber;
  adhocLimitAmount: BigNumber;
  drawingPower: BigNumber;
  termSpreadList: TermSpreadVOModel[];
  anchorUserList: AnchorUserVOModel[];
}

export function formattingToTempWaitingDealerAgreementVOModel(
  data: TempWaitingDealerAgreementVO,
): TempWaitingDealerAgreementVOModel {
  const { loanLimitAmount, adhocLimitAmount, drawingPower, termSpreadList, anchorUserList } = data;

  return {
    ...data,
    loanLimitAmount: sliceZeroDecimal(loanLimitAmount),
    adhocLimitAmount: sliceZeroDecimal(adhocLimitAmount),
    drawingPower: sliceZeroDecimal(drawingPower),
    termSpreadList: termSpreadList
      ? termSpreadList.map(termSpread => formattingToTermSpreadVOModel(termSpread))
      : termSpreadList,
    anchorUserList: anchorUserList
      ? anchorUserList.map(anchorUser => formattingToAnchorUserVOModel(anchorUser))
      : anchorUserList,
  };
}
